import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivityStreamChangedProperty, ActivityStreamHelper } from '@coin/shared/activity-stream/util';
import { EmployeeIdPipe } from '@coin/shared/auth/feature';
import { AuthComponentsModule } from '@coin/shared/auth/feature';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import { EnumToTextPipe, FormatUnknownValuePipe } from '@coin/shared/core/util-pipes';
import { TranslateModule } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-c-activity-stream-multiple-items',
  templateUrl: './activity-stream-multiple-items.component.html',
  styleUrls: ['./activity-stream-multiple-items.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LegacyComponentsModule,
    TranslateModule,
    NgTemplateOutlet,
    MatIcon,
    FormatUnknownValuePipe,
    EnumToTextPipe,
    AuthComponentsModule,
    EmployeeIdPipe,
    AsyncPipe,
    V2ButtonComponent
  ]
})
export class ActivityStreamMultipleItemsComponent {
  public items = input.required<ActivityStreamChangedProperty[]>();
  public showDetails = input<boolean>();
  public showDetailsClicked = output();

  protected filteredItems = computed(() => this.items().filter(item => !this.isPropertyHidden(item)));

  public onShowClicked(event?: MouseEvent): void {
    event?.stopPropagation();
    this.showDetailsClicked.emit();
  }

  public isDisplayedUnformatted(property: ActivityStreamChangedProperty): boolean {
    return ActivityStreamHelper.isDisplayedUnformatted(property);
  }

  public isEmployeeChange(property: ActivityStreamChangedProperty): boolean {
    return property.propertyName?.endsWith('EmployeeId') || property.propertyName?.endsWith('LineManagerId');
  }

  public nameEmployeeProperty(name: string): string {
    const employeeIdPostfix = 'EmployeeId';
    return name && name.indexOf(employeeIdPostfix) > 0 ? name.substring(0, name.indexOf(employeeIdPostfix)) : name;
  }

  private isPropertyHidden(property: ActivityStreamChangedProperty): boolean {
    return property.propertyName?.endsWith('CreatedById') || property.propertyName?.endsWith('UpdatedById');
  }
}
